import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
    name: 'momentPipe'
})
export class MomentPipe implements PipeTransform {
    transform(value: string, ...args: any[]): any {
        const [format] = args;
        return moment(value).format(format);
    }
}